import React from "react";
import { TransportOption } from "../../../models/financing-request/transport-option/TransportOption";
import { Grid, InputAdornment } from "@material-ui/core";
import TrTextField from "../../shared/controls/TrTextField";
import {
  nameof,
  getTooltipForDecimalInput,
  getCurrencyDisplayName,
} from "../../../utilities/utilities";
import CompanionInPublicTransportOption from "../../../models/financing-request/transport-option/CompanionInPublicTransportOption";
import ValidationResult from "../../../hooks/change-tracker/ValidationResult";
import TrackerName from "../../../models/financing-request/student-data/FinancingRequestStudentDataTrackerName";
import FinancingRequestStudentData from "../../../models/financing-request/student-data/FinancingRequestStudentData";
import useCodeBook from "../../../hooks/codebook/useCodeBook";
import TrSelectData from "../../../models/shared/TrSelectData";
import { CompanionInPublicTransportType } from "../../../models/companion-transport-types/CompanionInPublicTransportType";
import TrSelect from "../../shared/controls/TrSelect";
import SelectItem from "../../../models/shared/SelectItem";
import useInput from "../../../hooks/input/useInput";
import Currency from "../../../models/shared/Currency";

interface Props {
  index: number;
  transportOption: TransportOption;
  validationResult: ValidationResult;
  currency: Currency;
  onChange: (e: any) => void;
  onSelectChange: (e: any) => void;
}

export default function CompanionInPublicTransportItem({
  index,
  transportOption,
  validationResult,
  currency,
  onChange,
  onSelectChange,
}: Props) {
  let companionInPublicTransportOption = transportOption as CompanionInPublicTransportOption;

  const { companionTransportTypeSelectItems } = useCodeBook({
    getCompanionTransportType: true,
  });

  return (
    <>
      <Grid item lg={3} md={6} sm={12} xs={12}>
        <TrSelect
          required
          label={"Vrsta karte"}
          value={
            companionInPublicTransportOption.companionInPublicTransportType
          }
          name={nameof<typeof companionInPublicTransportOption>(
            "companionInPublicTransportType"
          )}
          fullWidth={true}
          selectData={
            {
              valueProp: "value",
              textProp: "text",
              data: companionTransportTypeSelectItems,
            } as TrSelectData<SelectItem<CompanionInPublicTransportType>>
          }
          onChange={onSelectChange}
          error={
            !validationResult.isArrayPropertyWithParrentValid(
              TrackerName.StudentsData,
              index.toString(),
              nameof<FinancingRequestStudentData>("transportOption"),
              nameof<CompanionInPublicTransportOption>(
                "companionInPublicTransportType"
              )
            )
          }
        />
      </Grid>
      <Grid item lg={3} md={6} sm={12} xs={12}>
        {companionInPublicTransportOption.companionInPublicTransportType ? (
          <TrTextField
            required
            label={`Cijena ${
              companionInPublicTransportOption.companionInPublicTransportType &&
              companionInPublicTransportOption.companionInPublicTransportType ==
                CompanionInPublicTransportType.Monthly
                ? "mjesečne"
                : "dnevne"
            } karte`}
            name={nameof<typeof companionInPublicTransportOption>(
              "ticketPrice"
            )}
            value={
              companionInPublicTransportOption.ticketPrice != null
                ? companionInPublicTransportOption.ticketPrice
                : ""
            }
            onChange={onChange}
            className="textField"
            type="number"
            tooltip={getTooltipForDecimalInput()}
            helperText={`U slučaju da se javnim prijevozom voze učenik i pratitelj, potrebno je unijeti zbroj iznosa ${
              companionInPublicTransportOption.companionInPublicTransportType &&
              companionInPublicTransportOption.companionInPublicTransportType ==
                CompanionInPublicTransportType.Monthly
                ? "mjesečnih"
                : "dnevnih"
            } karata`}
            InputProps={{
              endAdornment: <InputAdornment position="end">{getCurrencyDisplayName(currency)}</InputAdornment>,
            }}
            error={
              !validationResult.isArrayPropertyWithParrentValid(
                TrackerName.StudentsData,
                index.toString(),
                nameof<FinancingRequestStudentData>("transportOption"),
                nameof<CompanionInPublicTransportOption>("ticketPrice")
              )
            }
          />
        ) : (
          <></>
        )}
      </Grid>
    </>
  );
}
